import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { useDispatch } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { useNavigate } from 'react-router-dom';
import { Message } from 'primereact/message';
import { LoginService } from '../services/LoginService';
import { getSpecialityData } from '../reduxactions/adminactions/AdminPlanActions';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Admin_API } from '../ApiNames';

export const AdminPlan = () => {
    const uid = window.sessionStorage.getItem('uid');

    const [globalFilter, setGlobalFilter] = useState('');

    const data = useSelector((state: RootState) => state.plan.get);

    const dispatch = useDispatch();


    const toast = useRef(data);

    //To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(getSpecialityData() as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffectOnce(() => {
        fetchDataAsync();
    }, [dispatch]);
    const [addDilog, setaddDilog] = useState(false);
    const [Category, setCategory] = useState('');
    const [amount, setAmount] = useState('');

    const addPlan = async () => {
        try {
            const payload = { category: Category, amount: amount, q: 2 };
            const apiname = Admin_API.plan_API;
            const data1 = await LoginService.getData(apiname, payload);
            fetchDataAsync();
            setaddDilog(false);
        } catch (error) {

        }
    };
    const [updateDilog, setupdateDilog] = useState(false);
    const [editData, setEditData] = useState({
        Category: '',
        amount: '',
        PlanID: '',

    });


    const editupload = (rowData: any) => {
        setEditData({
            Category: rowData.Category,
            amount: rowData.Amount,
            PlanID: rowData.PlanID,



        });
        setupdateDilog(true);
    }

    const Close = () => {
        setaddDilog(false);
        setupdateDilog(false);
        setDeleteConfirmation(false);
    }
    const editplan = async () => {
        try {
            const { Category, amount, PlanID } = editData;
            const payload = { category: Category, amount: amount, pid: PlanID, q: 3 };
            const apiname = Admin_API.plan_API;
            const data = await LoginService.getData(apiname, payload);
            if (data) {
                toast.current.show({ severity: 'success', detail: data, life: 3000 });
            }
            fetchDataAsync();
            setupdateDilog(false);
        } catch (error) {

        }
    };
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);

    const [removedata, setRemoveData] = useState({
        PlanID: '',
    });

    const Removeduring = (rowData: any) => {
        setRemoveData({
            PlanID: rowData.PlanID,
        });
        setDeleteConfirmation(true);
    }

    const confirmDelete = async () => {
        const { PlanID } = removedata;
        const payload = { pid: PlanID, q: 4 };
        const apiname = Admin_API.plan_API;
        const data = await LoginService.getData(apiname, payload);
        if (data) {
            toast.current.show({ severity: 'error', summary: 'Successfully Delete.', life: 3000 });
        }
        setDeleteConfirmation(false);
        fetchDataAsync()
    };
//for help
 const [openHelp, setHelp] = useState(false);
 const url1 = window.sessionStorage.getItem("apiRoot");
 const IUrl = `${url1}/help/adminplan.php`;
 const helpImg = `${url1}/help/help3.png`;
 const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
   event.preventDefault();
   const newWindowReference = window.open(
     targetUrl,
     'newwindow',
     'width=1000,height=1000,noopener,noreferrer'
   );
 
   if (newWindowReference) {
       newWindowReference.opener = null;
   }
 };


    return (
        <div className="admin-layout-container">
            <div className="content-wrapper" style={{ marginLeft: '100px' }}>
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="grid mb-2">
                            <div className="col-6">
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content" style={{ marginLeft: '110px' }} >
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card-header p-2" style={{ marginTop: '50px' }}>
                                <h2>Plan List</h2>
                            </div>
                            <div className="col-16" style={{ textAlign: "right" }}>
                                <a
                                    title="help"
                                    onClick={(e) => openWindow(e, IUrl)}
                                    style={{

                                        color: "blue",
                                        fontSize: 15, cursor: "pointer"
                                    }}
                                >Help for this Page &nbsp;
                                    <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                </a>
                            </div>
                            <br></br>
                            <div className="card flex flex-wrap justify-content-end" style={{ marginRight: '30px' }}>
                                <Button label="Add Plan" severity="info" onClick={() => setaddDilog(true)} />
                            </div>
                            <div className="box box-primary">
                                <div className="card">
                                    <p className="m-0">
                                        <div>
                                            <div className="card flex flex-wrap justify-content">
                                                <span className="p-input-icon-left">
                                                    <i className="pi pi-search" style={{ paddingLeft: '5px' }} />
                                                    <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" style={{ paddingLeft: '25px' }} />
                                                </span>

                                            </div>
                                            <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                globalFilterFields={['Category', 'Amount', 'Phone', 'Status']} >
                                                <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                <Column field="Category" sortable header="Category Name"></Column>
                                                <Column field="Amount" sortable header="Amount"></Column>

                                                <Column header="Operation" body={(rowData) => (
                                                    <>

                                                        <Button className='mr-1' tooltip="Edit" severity="info" icon="pi pi-pencil" rounded outlined onClick={() => editupload(rowData)} />
                                                        <Button className='mr-6' tooltip="Delete" severity="danger" icon="pi pi-trash" rounded outlined onClick={() => Removeduring(rowData)} />

                                                    </>
                                                )} />
                                            </DataTable>

                                        </div>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Dialog
                header="Add Plan"
                visible={addDilog}
                style={{ width: '29vw', height: '42vh' }}
                onHide={() => setaddDilog(false)}
            >
                <div className="grid pt-0" style={{ marginBottom: '2px', alignItems: 'center' }}>
                    <div className="col-2" style={{ paddingRight: '0', marginRight: '0' }}>
                        <label htmlFor="name" className="control-label" style={{ marginRight: '5px' }}>Category:</label>
                    </div>
                    <div className="col-6" style={{ paddingLeft: '0' }}>
                        <InputText
                            id="name"
                            style={{ width: '18vw', marginBottom: '5px', marginLeft: '5px' }}
                            name="Contest Name"
                            placeholder='Enter Category'
                            onChange={(e) => setCategory(e.target.value)}
                        />
                    </div>
                </div>

                <div className="grid pt-0" style={{ marginBottom: '2px', alignItems: 'center' }}>
                    <div className="col-2" style={{ paddingRight: '0', marginRight: '0' }}>
                        <label htmlFor="email" className="control-label" style={{ marginRight: '5px' }}>Amount:</label>
                    </div>
                    <div className="col-6" style={{ paddingLeft: '0' }}>
                        <InputText
                            id="email"
                            style={{ width: '18vw', marginBottom: '5px', marginLeft: '5px' }}
                            name="Email"
                            placeholder='Enter Amount'
                            onChange={(e) => setAmount(e.target.value)}
                        />
                    </div>
                </div>

                <Button label="Close" onClick={Close} severity="secondary" />
                <Button label="Add" onClick={addPlan} style={{ float: 'right' }} />
            </Dialog>
            <Dialog
                header="Edit Plan"
                visible={updateDilog}
                style={{ width: '29vw', height: '42vh' }}
                onHide={() => setupdateDilog(false)}
            >
                <div className="grid pt-0" style={{ marginBottom: '2px', alignItems: 'center' }}>
                    <div className="col-2" style={{ paddingRight: '0', marginRight: '0' }}>
                        <label htmlFor="name" className="control-label" style={{ marginRight: '5px' }}>Category:</label>
                    </div>
                    <div className="col-6" style={{ paddingLeft: '0' }}>
                        <InputText id="name" style={{ width: '18vw', marginBottom: '20px', marginLeft: '25px' }} name="Doctitle" onChange={(e) => setEditData({ ...editData, Category: e.target.value })} value={editData.Category} />
                    </div>
                </div>

                <div className="grid pt-0" style={{ marginBottom: '2px', alignItems: 'center' }}>
                    <div className="col-2" style={{ paddingRight: '0', marginRight: '0' }}>
                        <label htmlFor="email" className="control-label" style={{ marginRight: '5px' }}>Amount:</label>
                    </div>
                    <div className="col-6" style={{ paddingLeft: '0' }}>
                        <InputText id="name" style={{ width: '18vw', marginBottom: '20px', marginLeft: '25px' }} name="Doctitle" onChange={(e) => setEditData({ ...editData, amount: e.target.value })} value={editData.amount} />
                    </div>
                </div>

                <Button label="Close" onClick={Close} severity="secondary" />
                <Button label="Update" onClick={editplan} style={{ float: 'right' }} />
            </Dialog>

            < Dialog header="Conform Delete " style={{ width: '30vw' }} visible={deleteConfirmation} onHide={() => setDeleteConfirmation(false)}>
                <div>Are you really want to Remove...?</div>
                <br></br>
                <Button label="Close" onClick={Close} className="mr-3 p-button-secondary" />
                <Button label="Delete" className='mr-3 p-button-raised' onClick={confirmDelete} />
            </Dialog >



            <Toast ref={toast} >
                <Message severity="success" />
            </Toast>


        </div>
    )
}
